import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import style from './ohCleoInMedia.module.css';

const OhCleoInMedia = () => {
  const data = useStaticQuery(
    graphql`
      query {
        allContentfulWebpagePressAbstract(
          sort: { fields: publishDate, order: DESC }
        ) {
          edges {
            node {
              title {
                title
              }
              summary {
                summary
              }
              id
              link
              translated
              publishDate(formatString: "MMMM Do, YYYY")
              image {
                fluid(maxWidth: 600, resizingBehavior: FILL) {
                  ...GatsbyContentfulFluid
                }
              }
            }
          }
        }
      }
    `,
  );

  const mediaData = data.allContentfulWebpagePressAbstract.edges;

  return (
    <main className={style.mediaContainer}>
      <h3>OhCleo in Media</h3>
      <section className={style.mediaWrapper}>
        {mediaData.map(data => (
          <aside key={data.node.id}>
            <p className="caption">{data.node.publishDate}</p>
            {data.node.translated ? (
              <div className={`${style.translateTag} bodytext-2`}>
                Translated Summary
              </div>
            ) : (
              <div className={style.notTranslated}></div>
            )}
            <h4>
              <a href={data.node.link} target="_blank">
                {data.node.title.title}
              </a>
            </h4>
            <p className="bodytext-1">{data.node.summary.summary}</p>
            <div className={style.imageContainer}>
              <Img fluid={data.node.image.fluid} alt={'App promo'} />
            </div>
          </aside>
        ))}
      </section>
    </main>
  );
};

export default OhCleoInMedia;
